// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1i2jR","calendarButtons":"ClockData_calendarButtons__52gDm"};